import { useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'
import Icon from 'components/icon'

type Props = {
  menus: Array<{ label: string; action: () => void }>
}

export function ActionButton(props: Props) {
  const { menus } = props
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Icon icon='MoreHoriz' />
      </IconButton>
      <Menu
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menus.map((menu, index) => (
          <MenuItem key={index} onClick={() => menu.action()}>
            {menu.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
